import React from "react";
import PropTypes from "prop-types";
import OfferIcon from '@sfly/uig-svg-icon/store/offer-icon';

export default function DisplayPricing(props) {
    const {listTotalPrice, saleTotalPrice, promoMessage} = props;
    const isDiscounted = listTotalPrice > saleTotalPrice;

    if (listTotalPrice > 0) {
        return (
            <div>
                <div className="pricing-option">
                    <span className={`unit-price ${isDiscounted ? "discounted" : ""}`}>
                        {
                            isDiscounted &&
                            <React.Fragment>
                                <span className="text-from">From</span>
                                <del>${listTotalPrice.toFixed(2)}</del>
                            </React.Fragment>
                        }
                        <span className="original-price">${saleTotalPrice.toFixed(2)}</span>
                    </span>
                </div>
                <div className="promo-text"> {promoMessage !== null ? <OfferIcon/> : null} {promoMessage}</div>
            </div>
        );
    } else {
        return (
            <div className="commonStyle priceText">
                <p>Add to cart to see price</p>
            </div>
        );
    }
}

DisplayPricing.propTypes = {
    listTotalPrice: PropTypes.number.isRequired,
    saleTotalPrice: PropTypes.number.isRequired
};
